import { Component, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit, Input } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { PermisoService } from '../../services/permiso.service';
import { SessionService } from '../../services/session.service';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any;
//Metadata
export interface RouteInfo {
	path: string;
	title: string;
	_id: string,
	type: string;
	icontype: string;
	// icon: string;
	children?: ChildrenItems[];
}

export interface ChildrenItems {
	path: string;
	title: string;
	_id?: string,
	ab?: string;
	icontype?: string;
	type?: string;
	children?: Array<any>
}

//Menu Items
/*export const ROUTES: RouteInfo[] = [
	{
		path: '/general',
		title: 'General',
		_id: 'general',
		type: 'sub',
		icontype: 'fa fa-university',
		children: [
			{ path: 'empresas-view', title: 'Empresa', ab: '-', type: 'link' },
			{ path: 'sucursales-list', title: 'Sucursal', ab: '-', type: 'link' },
		]
	},

	{
		path: '/configuracion',
		title: 'Configuracion',
		_id: 'configuracion',
		type: 'sub',
		icontype: 'fa fa-cog',
		children: [
			{ path: 'parametros-list', title: 'Parametros', ab: '-', type: 'link' },
		]
	},
	{
		path: '/compras',
		title: 'Compras',
		_id: 'compras',
		type: 'sub',
		icontype: 'ti-bag',
		children: [
			{ path: 'proveedores-list', title: 'Proveedores', ab: '-', type: 'link' },
			{ path: 'compras-list', title: 'Registrar compras', ab: '-', type: 'link' },
		]
	},
	{
		path: '/ventas',
		title: 'Ventas',
		_id: 'ventas',
		type: 'sub',
		icontype: 'ti-support',
		children: [
			{ path: 'clientes-list', title: 'Clientes', ab: '-', type: 'link' },
			{ path: 'cajas-list', title: 'Caja', ab: '-', type: 'link' },
			{ path: 'comprobantes-list', title: 'Comprobantes', ab: '-', type: 'link' },
			{ path: 'ventas-list', title: 'Registrar venta', ab: '-', type: 'link' }
		]
	},
	{
		path: '/cobro',
		title: 'Cobro',
		_id: 'cobro',
		type: 'sub',
		icontype: 'fa fa-money',
		children: [
			{ path: 'bancos-list', title: 'Banco', ab: '-', type: 'link' },
			{ path: 'forma-pago-list', title: 'Formas de pagos', ab: '-', type: 'link' },
			{ path: 'arqueo-caja-crear', title: 'Arqueo de caja', ab: '-', type: 'link' },
		]
	},
	{
		path: '/inventario',
		title: 'Inventario',
		_id: 'inventario',
		type: 'sub',
		icontype: 'ti-layers-alt',
		children: [
			{ path: "unidades-medida-list", title: 'Unidad medida', ab: '-', type: 'link' },
			{ path: 'categorias-list', title: 'Categorías', ab: '-', type: 'link' },
			{ path: 'bodegas-list', title: 'Bodegas', ab: '-', type: 'link' },
			{ path: 'productos-list', title: 'Productos', ab: '-', type: 'link' },
			{ path: 'precio-venta-list', title: 'Precios', ab: '-', type: 'link' },
			{ path: 'transferencias-list', title: 'Transferencias', ab: '-', type: 'link' },
		]
	},

	{
		path: '/seguridad',
		title: 'Seguridad',
		type: 'sub',
		_id: 'seguridad',
		icontype: 'fa fa-th',
		children: [
			{ path: 'menus-list', title: 'Menús', ab: '-', type: 'link' },
			{ path: 'perfiles-list', title: 'Perfil', ab: '-', type: 'link' },
			{ path: 'permisos-list', title: 'Permiso', ab: '-', type: 'link' },
			{ path: 'usuarios-list', title: 'Usuarios', ab: '-', type: 'link' },
			{ path: 'menu-perfil-crear', title: 'Menu Perfil', ab: '-', type: 'link' },
		]
	}
];*/
//export var ROUTES = [];

@Component({
	moduleId: module.id,
	selector: 'sidebar-cmp',
	templateUrl: 'sidebar.component.html',
	providers: [PermisoService]
})

export class SidebarComponent {
	//@Input() public userLogin: any;
	public loading: boolean = false;
	public menuItems: any[];
	public usuario: any = {
        usuario: "",
        persona: {
            nombres: "",
            apellido_paterno: "",
            apellido_materno: "",
        },
        perfil: {
            nombre: ""
        }
    };
	public menuRoutes: RouteInfo[] = [];

	constructor(
		protected localStorage: AsyncLocalStorage,
		public permisoService: PermisoService,
		private ss: SessionService,
		private NavRoute: Router,
	){
		this.loading = true;
		this.permisoService.getAll("?usuario="+sessionStorage.getItem('usuario_id')+"&perfil="+sessionStorage.getItem("perfil_id")).subscribe(
			res => {
				this.menuItems = res;
				//ROUTES = res;
				
				this.localStorage.setItem('menuItems',this.menuItems).subscribe();
				this.loading = false;
			},
			err => {
				this.loading = false;
			}
		);
	}

	isNotMobileMenu() {
		if ($(window).width() > 991) {
			return false;
		}
		return true;
	}

	ngOnInit() {
		/*this.localStorage.getItem('_usuario').subscribe(
			data => {
				this.usuario = data;
			}
		);*/

		this.usuario.nombres = this.ss.getData('nombres');
        this.usuario.apellidos = this.ss.getData('apellidos');
        this.usuario.usuario = this.ss.getData('usuario');
		this.usuario.perfil = this.ss.getData('perfil');
        this.usuario.sucursal = this.ss.getData('sucursal');

		var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
		//this.menuItems = ROUTES.filter(menuItem => menuItem);

		isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

		if (isWindows) {
			// if we are on windows OS we activate the perfectScrollbar function
			$('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
			$('html').addClass('perfect-scrollbar-on');
		} else {
			$('html').addClass('perfect-scrollbar-off');
		}
	}
	
	ngAfterViewInit() {
		var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();

		var collapseId = $sidebarParent.siblings('a').attr("href");

		$(collapseId).collapse("show");
	}

	logout(){
        this.ss.deleteData().then(
            () => {
                this.NavRoute.navigate(['login'])
                //window.location.href = dashboard_url;
            }
        );
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/layouts/sidebar/sidebar.component.ts